import React from "react";

const SIZE_CLASS = {
  sm: "ui-loading-spinner-sm",
  md: "ui-loading-spinner-md",
  lg: "ui-loading-spinner-lg",
};

const LoadingIndicator = ({
  label = "Loading...",
  size = "md",
  className = "",
  showLabel = true,
  invert = false,
}) => {
  const sizeClass = SIZE_CLASS[size] || SIZE_CLASS.md;
  // Default slate-700 for light surfaces; invert for primary (white-on-color) buttons.
  const textColor = invert ? "text-white" : "text-slate-700";

  return (
    <span className={`ui-loading-inline ${textColor} ${className}`.trim()}>
      <span
        className={`ui-loading-spinner ${sizeClass} ${
          invert ? "ui-loading-spinner-on-dark" : ""
        }`}
        aria-hidden="true"
      />
      {showLabel ? <span className="font-medium">{label}</span> : null}
    </span>
  );
};

export default LoadingIndicator;
